// eslint-disable-next-line import/prefer-default-export
export function currencyFormat(value: number) {
  return value.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
  });
}
